var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-vide-assets"},[_c('h2',{staticClass:"mb-5"},[_vm._v("Video assets")]),_c('VideoSlider',{attrs:{"items":_vm.product.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }